var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1237 1.4502H9.87498C8.35335 1.4502 7.11621 2.68937 7.11621 4.21071V24.7906C7.11621 26.3119 8.35335 27.5505 9.87498 27.5505H19.124C20.645 27.5505 21.8839 26.3119 21.8839 24.7906V4.21071C21.8836 2.68937 20.6447 1.4502 19.1237 1.4502ZM13.125 2.33267H15.8739C16.1822 2.33267 16.4252 2.6334 16.4252 3.01823C16.4252 3.40306 16.1822 3.70408 15.8739 3.70408H13.125C12.817 3.70408 12.5731 3.40306 12.5731 3.01823C12.5731 2.6334 12.8167 2.33267 13.125 2.33267ZM14.4985 26.5529C13.7149 26.5529 13.0772 25.9152 13.0772 25.1313C13.0772 24.3477 13.7149 23.71 14.4985 23.71C15.282 23.71 15.9192 24.3477 15.9192 25.1313C15.9195 25.9149 15.282 26.5529 14.4985 26.5529ZM20.3622 22.8771H8.63523V4.44908H20.3622V22.8771Z",
    fill: "#003333",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.9efca178.svg";
export { ForwardRef as ReactComponent };